"use client";
import { useCardCaptureConfirmHandler } from "@/features/card-capture/hooks/useCardCaptureConfirmHandler";
import { useConfirmStaffCardCapture } from "./useConfirmStaffCardCapture";
import { useUpdateCardOnFileCache } from "@/features/patient/hooks/useUpdateCardOnFileCache";

/**
 * Handles a successful Stripe `confirmSetup`: confirms the capture with the
 * backend and, when a card is returned, syncs it into the patient details +
 * card collection caches. `onConfirmed` always runs afterwards, whether or not a
 * card came back.
 */
export function useCardCaptureSuccessHandler(
  patientId: string,
  practiceId: string,
  onConfirmed: VoidFunction,
) {
  const confirmStaffCardCapture = useConfirmStaffCardCapture(practiceId);
  const updateCardOnFileCache = useUpdateCardOnFileCache(patientId);

  return useCardCaptureConfirmHandler(
    (setupIntentId) => confirmStaffCardCapture.mutateAsync(setupIntentId),
    updateCardOnFileCache,
    onConfirmed,
  );
}
